import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
// import * as walletAdapterWallets from '@solana/wallet-adapter-wallets';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import * as web3 from '@solana/web3.js';

import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import { RPC_ENDPOINT } from '../constants/apiPaths';
import { useMemo } from 'react';

import { PhantomWalletAdapter } from '@solana/wallet-adapter-phantom';
// require('@solana/wallet-adapter-react-ui/styles.css');

const WalletContextProvider = ({ children }) => {
    // const endpoint = RPC_ENDPOINT;

    // const walletList = [
    //     new walletAdapterWallets.PhantomWalletAdapter(),
    //     new walletAdapterWallets.WalletConnectWalletAdapter(),
    //     // new walletAdapterWallets.SolflareWalletAdapter()
    // ];

    const network = WalletAdapterNetwork.Mainnet;
    const endpoint = useMemo(() => web3.clusterApiUrl(network), [network]);
    const wallets = useMemo(
        () => [
            new PhantomWalletAdapter(),
            // Add other wallets here
        ],
        [network]
    );

    return (
        <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} autoConnect={true}>
                <WalletModalProvider>{children}</WalletModalProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
};

export default WalletContextProvider;
